import { createRouter, createWebHistory } from 'vue-router'
import LangingHomePage from '../views/Landing/FrontPageView.vue'
import FrontTrackView from '../views/Tracking/FrontTrackView.vue'
import FrontBookView from '../views/Booking/FrontBookView.vue'
import TrackDetailsView from '../views/Tracking/Home/ViewUserDetails.vue'
import HomeViewPage from '@/views/Home/HomeViewPage.vue'
import FormPage from '@/components/Booking/ApplicationForms/Form.vue';

import ResheduleEntireBooking from '@/components/Appointment/Sections/History/ResheduleEntireBooking.vue';
import ResheduleSingleBooking from '@/components/Appointment/Sections/History/SingleReshedule.vue';
import EditSingleBooking from '@/components/Appointment/Sections/History/EditForm.vue';
import EditEntireTrack from '@/components/Appointment/Sections/History/More/EditEntireTrack.vue';

import ResheduleEntireDetails from '@/components/Appointment/Sections/Details/ResheduleEntireDetails.vue';
import SingleDetailsReshedule from '@/components/Appointment/Sections/Details/SingleDetailsReshedule.vue';
import DetailsEditForm from '@/components/Appointment/Sections/Details/DetailsEditForm.vue';
import EditEntireDetailsForm from '@/components/Appointment/Sections/Details/More/EditEntireDetailsForm.vue';

import NewMember from '@/components/Appointment/Sections/Details/AddNewMember/NewMember.vue';
import ShowForm from '@/components/Appointment/Sections/Details/AddNewMember/ShowForm.vue';
import NotFound from '@/views/NotFound.vue';

import privacyPolicy from '@/components/Policy/privacyPolicy.vue';
import termsConditions from '@/components/Policy/termsConditions.vue';

import { useUserStore } from '@/store/user'


let logoutTimer = null;
let activityListenersSet = false;

function resetLogoutTimer(userStore, router) {
  if (logoutTimer) clearTimeout(logoutTimer);
  
  logoutTimer = setTimeout(() => {
    userStore.setToken(null);
    userStore.setUser(null);
    localStorage.removeItem('authToken');
    router.push({ name: 'trackAppointment' });
  }, 3600000); //60000 1 minute // 3600000 ihr
}

function setupActivityListeners(userStore, router) {
  if (activityListenersSet) return;

  ['click', 'mousemove', 'keydown', 'scroll', 'touchstart'].forEach(event => {
    window.addEventListener(event, () => {
      resetLogoutTimer(userStore, router);
    });
  });

  activityListenersSet = true;
  
}



const routes = [
  { path: '/home-section', name: 'landingPage', component: LangingHomePage },
  { path: '/', name: 'HomePage', component: HomeViewPage },
  { path: '/trackAppointment', name: 'trackAppointment', component: FrontTrackView },
  { path: '/bookAppointment/:id', name: 'bookAppointment', component: FrontBookView, props: true },
  { path: '/track/track-view-details', name: 'trackDetailsView', component: TrackDetailsView },
  { path: '/form', name: 'form', component: FormPage },
  { path: '/reshedule-entire-booking', name: 'resheduleEntireBooking', component: ResheduleEntireBooking, props: route => ({ booking: route.params.booking }) },
  { path: '/reshedule-single-booking', name: 'resheduleSingleBooking', component: ResheduleSingleBooking, props: route => ({ booking: route.params.booking })},
  { path: '/edit-single-booking-form', name: 'editSingleBookingForm', component: EditSingleBooking, props: route => ({ booking: route.params.booking })},
  { path: '/edit-entire-booking-form', name: 'editEntireTrack', component: EditEntireTrack, props: route => ({ booking: route.params.booking })},

  { path: '/reshedule-entire-booking-details', name: 'detailsResheduleEntireBooking', component: ResheduleEntireDetails, props: route => ({ booking: route.params.booking }) },
  { path: '/reshedule-single-booking-details', name: 'detailsResheduleSingleBooking', component: SingleDetailsReshedule, props: route => ({ booking: route.params.booking })},
  { path: '/edit-single-booking-form-details', name: 'detailsEditSingleBookingForm', component: DetailsEditForm, props: route => ({ booking: route.params.booking })},
  { path: '/edit-entire-booking-form-details', name: 'detailsEditEntireTrack', component: EditEntireDetailsForm, props: route => ({ booking: route.params.booking })},

  { path: '/add-new-member/:entityId', name: 'NewMemberPaymentSummary', component: NewMember, props: route => ({ entityId: route.params.entityId, applicants: Number(route.query.applicants) }) },
  { path: '/show-form/:entityId', name: 'ShowForm', component: ShowForm, props: route => ({ entityId: route.params.entityId, applicants: route.query.applicants }) },

  { path: '/privacy-policy', name: 'PrivacyPolicy', component: privacyPolicy },
  { path: '/terms-conditions', name: 'TermsConditions', component: termsConditions },

  // Catch-all route (must be last)
  { path: '/:pathMatch(.*)*', name: 'NotFound', component: NotFound }

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});


router.beforeEach((to, from, next) => {
  const userStore = useUserStore();
  const token = localStorage.getItem('authToken');

  if (!userStore.authToken && token) {
    userStore.authToken = token;
  }

  if (to.name === 'trackDetailsView' && !userStore.authToken) {
    return next({ name: 'trackAppointment' });
  }

  if (userStore.authToken) {
    resetLogoutTimer(userStore, router);
    setupActivityListeners(userStore, router);
  }

  next();
});




export default router
